import(/* webpackMode: "eager" */ "/Users/panxo/Development/LigasDeportivas/web/src/app/[locale]/error.tsx");
